document.addEventListener("DOMContentLoaded", function() {
  var elementsToCheck = document.querySelectorAll('.text-subdued');

  elementsToCheck.forEach(function(element) {
    var textContent = element.textContent.trim();
    if (textContent.includes('Color') || textContent.includes('Finish') || textContent.includes('Material')  || textContent.includes('Style') ) {
      var parentOption = element.closest('.variant-picker__option');
      if (parentOption) {
        parentOption.style.display = 'none';
      }
    }
  });
});
